import React from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import {   Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import { toggleThinkToolPopup, toggleUserDashboard } from '../../redux/reducers/view';
import { withRouter } from 'react-router-dom';

import { learnerVersionsRequest } from '../../redux/reducers/savedVersions';
import Popup from '../Popup';

import { commonStyles } from '../../styles/styles';
import questionsImage from '../../assets/questions-circular.svg';


import {
  MDBBtn
} from "mdbreact";

const ThinkToolPopup = ({
  classes,
  programsFull,
  toggleThinkToolPopup,

  onVersionsButtonClick,
  savedVersions,
  hidePopup,
  onStartAgainButtonClick,
  ...props
}) => {
  const { selectedContentId, selectedModuleId, selectedProgramId } = programsFull;
  return savedVersions.isFetched === true ? (
    <Popup>
      <div className="popupHolder">
        <div className="iframePopup">
          <div className={classes.popupHeader}>
            <Clear className={classes.closePopup} onClick={() => toggleThinkToolPopup(false)} />
            <div className={classes.popupTitle}>
              
            </div>
            <div className={classes.popupCopy}>
              How do you want to access your thinktool?
            </div>
          </div>
          <div className={`${classes.popupBody} ${classes.buttonWrapper}`}>
            <Link
              to={`${selectedContentId}`}
              className={`${classes.link} ${classes.currentLink}`}
              onClick={hidePopup}
            >
            <MDBBtn color="success"
                size="md"
                variant="contained" 
                className='mt-5'
                action
                onClick={onStartAgainButtonClick}>
              START AGAIN
            </MDBBtn>
          
            </Link>
            {savedVersions.learnerVersions.length > 0 && (
              <MDBBtn 
                  size="md"
                  variant="contained" 
                  className='mt-5 danger-color-dark'
                  onClick={onVersionsButtonClick}
                  action>
                  MY VERSIONS
              </MDBBtn>
         
            )}
          </div>
        </div>
      </div>
    </Popup>
  ) : null;
};

const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  currentLink: {
    width: 'auto',
  },
  button: {
    width: 100,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: 30,
  },
  header: {
    textAlign: 'center',
  },
});

const mapStateToProps = state => ({
  programsFull: state.userProgramsFullReducer,
  savedVersions: state.savedVersionsReducer,
});

const mapDispatchToProps = dispatch => ({
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    onVersionsButtonClick: props => () => {
      const { toggleUserDashboard, toggleThinkToolPopup } = props;
      toggleThinkToolPopup(false);
     
      props.history.push('/versions/'+props.programsFull.selectedProgramId+'/'+props.programsFull.selectedContentId+ props.history.location.search)
    },

    onStartAgainButtonClick: props => () => {
      const { toggleUserDashboard, toggleThinkToolPopup } = props;
      toggleThinkToolPopup(false);
      props.history.push('/tools/'+props.programsFull.selectedProgramId+'/'+props.programsFull.selectedContentId+ props.history.location.search)
    },

  //   <Link
  //   to={`${
  //     location.pathname
  //   }/${selectedProgramId}/${selectedModuleId}/${selectedContentId}`}
  //   className={`${classes.link} ${classes.currentLink}`}
  //   onClick={hidePopup}
  // >
    hidePopup: props => () => {
      props.toggleThinkToolPopup(false);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.learnerVersionsRequest();
    },
  }),
  withStyles(styles),
)(ThinkToolPopup);

ThinkToolPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  programsFull: PropTypes.instanceOf(Object),
  toggleThinkToolPopup: PropTypes.func,
  location: PropTypes.instanceOf(Object),
  savedVersions: PropTypes.instanceOf(Object),
  onVersionsButtonClick: PropTypes.func,
  hidePopup: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Components/Popups/ThinkToolPopup.jsx